import React from 'react';
import PropTypes from 'prop-types';
import VerbButton from '../../../../shared/components/VerbButton';
import Image from '../../../../shared/components/Image';

const MyPathwayUpNextCard = ({
    isTeamPage,
    upNext,
    history,
    onClickBack,
    buttonText,
    CTAClickHandler,
    markTaskAsCompleted,
    updateUserPathwayContentItem,
    pathwayCompleted
}) => {
    let upNextButton;
    let assetImageClick;

    if (
        upNext.type === 'TASK' ||
        upNext.parentType === 'TASK' ||
        upNext.type === 'EVENT' ||
        upNext.parentType === 'EVENT'
    ) {
        const markTaskCompleteFunction = isTeamPage
            ? () => updateUserPathwayContentItem(upNext, upNext?.index)
            : () => markTaskAsCompleted(upNext?.index);
        upNextButton = (
            <div className={'card-link'}>
                <VerbButton
                    textId={'BUTTON_KEEP_LEARNING'}
                    defaultMessage={upNext.buttonText || buttonText} // for teams page pathway modal
                    onClick={markTaskCompleteFunction}
                />
            </div>
        );
    } else {
        assetImageClick = CTAClickHandler;
        upNextButton = (
            <div className={'card-link'}>
                <VerbButton
                    textId={'BUTTON_KEEP_LEARNING'}
                    defaultMessage={upNext.buttonText || buttonText}
                    onClick={CTAClickHandler}
                />
            </div>
        );
    }

    return (upNext?.isCompleted || pathwayCompleted) && !isTeamPage ? (
        <div className={'my-pathway-up-next'}>
            <div className={'next-asset-image-container col-md-6 col-xs-12'}>
                <Image
                    className={'next-asset-image'}
                    src={
                        'https://res.cloudinary.com/verb-prod/image/upload/v1594671134/Pathways_ActivityInterstitialHerbie1_sqmosa.png'
                    }
                    dimension={{ h: 225, w: 225 }}
                />
            </div>
            <div className={'asset-details col-md-6 col-xs-12'}>
                <h4 className={'asset-title asset-title-completed'}>Pathway Completed</h4>
                <div className={'asset-sub-title asset-sub-title-completed'}>
                    Continue your journey by picking another pathway from the dropdown menu or&nbsp;
                    <span
                        onClick={() => {
                            window.scrollTo(0, 0);
                            onClickBack('browse');
                        }}
                        className={'asset-sub-title-completed-link'}
                    >
                        choose a new pathway
                    </span>
                </div>
                {upNext.userPathwayId && (
                    <div className={'card-link'}>
                        <VerbButton
                            textId={'BUTTON_REVIEW'}
                            defaultMessage={'REVIEW'}
                            onClick={() => history.push(`/mypathway/${upNext.userPathwayId}/done`)}
                        />
                    </div>
                )}
            </div>
        </div>
    ) : (
        <div className={'my-pathway-up-next'}>
            <div className={'next-asset-image-container col-md-5 col-xs-12'} onClick={assetImageClick}>
                <Image className={'next-asset-image'} src={upNext.thumbnailImageUrl} dimension={{ h: 138, w: 138 }} />
            </div>
            <div className={'asset-details col-md-7 col-xs-12'}>
                <h4 className={'asset-title'}>{upNext.name}</h4>
                <div
                    className={'asset-sub-title'}
                    style={upNext.name && upNext.name.length <= 21 ? {} : { WebkitLineClamp: 3 }}
                >
                    {upNext.subtitle}
                </div>
                {upNextButton}
            </div>
        </div>
    );
};

MyPathwayUpNextCard.propTypes = {
    isTeamPage: PropTypes.bool,
    pathwayCompleted: PropTypes.bool,
    upNext: PropTypes.object,
    history: PropTypes.object,
    onClickBack: PropTypes.func,
    buttonText: PropTypes.string,
    CTAClickHandler: PropTypes.func,
    markTaskAsCompleted: PropTypes.func,
    updateUserPathwayContentItem: PropTypes.func
};
export default MyPathwayUpNextCard;
